import type { AccountExpense } from './types';

// Made-up expenses so the list can be reviewed before svc-contracting serves them. Only one Account has any, because
// most Accounts have no expenses. Delete with the API wiring.
export const SAMPLE_EXPENSES_BY_ACCOUNT: Readonly<Record<string, ReadonlyArray<AccountExpense>>> = {
  '0012800000cstdBAAQ': [
    {
      id: 'sample-expense-1',
      name: 'Accommodation',
      type: 'Accommodation',
      travelForm: 'Bali Market Visit Nov 2026',
      totalCost: 1460,
      currency: 'AUD',
      createdDate: '2026-09-22T23:23:33.000Z',
    },
    {
      id: 'sample-expense-2',
      name: 'Airport transfer to the resort',
      type: 'Transport',
      travelForm: 'Bali Market Visit Nov 2026',
      totalCost: 980,
      currency: 'AUD',
      createdDate: '2026-09-22T23:18:04.000Z',
    },
    {
      id: 'sample-expense-3',
      name: 'Meals',
      type: 'Dining/Meals',
      travelForm: 'Bali Market Visit Nov 2026',
      totalCost: 240,
      currency: 'AUD',
      createdDate: '2026-09-22T23:12:40.000Z',
    },
    {
      id: 'sample-expense-4',
      name: 'Hosted famil dinner',
      type: 'Entertainment',
      travelForm: 'Hosted Famil Mar 2026',
      totalCost: 650,
      currency: 'AUD',
      createdDate: '2026-02-24T22:37:42.000Z',
    },
    {
      id: 'sample-expense-5',
      name: 'Accommodation',
      type: 'Accommodation',
      travelForm: 'Hosted Famil Mar 2026',
      totalCost: 2104,
      currency: 'AUD',
      createdDate: '2026-02-24T22:31:15.000Z',
    },
    {
      id: 'sample-expense-6',
      name: 'Arrival visa',
      type: 'Visa',
      travelForm: 'Hosted Famil Mar 2026',
      totalCost: 50,
      currency: 'AUD',
      createdDate: '2026-02-24T22:20:51.000Z',
    },
    {
      id: 'sample-expense-7',
      name: 'Airport transfer',
      type: 'Transport',
      travelForm: 'ILTM Asia Pacific 2025',
      totalCost: 200,
      currency: 'AUD',
      createdDate: '2025-05-12T01:45:54.000Z',
    },
  ],
};
